export const getRarityColor = (rarity: string, type: string): string => {
  rarity = rarity ? rarity.toLowerCase() : "";
  if (type === "text") {
    switch (rarity) {
      case "uncommon":
        return "text-rarity-uncommon";
      case "rare":
        return "text-rarity-rare";
      case "epic":
        return "text-rarity-epic";
      case "legendary":
        return "text-rarity-legendary";
      case "exotic":
        return "text-rarity-exotic";
      case "mythic":
        return "text-rarity-mythic";
      case "unique":
        return "text-rarity-unique";
      default:
        return "text-neutral-200";
    }
  } else if (type === "bg") {
    switch (rarity) {
      case "common":
        return "bg-rarity-common text-black";
      case "uncommon":
        return "bg-rarity-uncommon text-black";
      case "rare":
        return "bg-rarity-rare text-neutral-200";
      case "epic":
        return "bg-rarity-epic text-neutral-200";
      case "legendary":
        return "bg-rarity-legendary text-black";
      case "exotic":
        return "bg-rarity-exotic text-black";
      case "mythic":
        return "bg-rarity-mythic text-neutral-200";
      case "unique":
        return "bg-rarity-unique text-black";
      default:
        return "";
    }
  } else if (type === "shadow") {
    switch (rarity) {
      case "common":
        return "shadow-common";
      case "uncommon":
        return "shadow-uncommon";
      case "rare":
        return "shadow-rare";
      case "epic":
        return "shadow-epic";
      case "legendary":
        return "shadow-legendary";
      case "exotic":
        return "shadow-exotic";
      case "mythic":
        return "shadow-mythic";
      case "unique":
        return "shadow-unique";
      case "test":
        return "shadow-test";
      default:
        return "";
    }
  } else if (type === "border") {
    switch (rarity) {
      case "common":
        return "border-rarity-common";
      case "uncommon":
        return "border-rarity-uncommon";
      case "rare":
        return "border-rarity-rare";
      case "epic":
        return "border-rarity-epic";
      case "legendary":
        return "border-rarity-legendary";
      case "mythic":
        return "border-rarity-mythic";
      case "unique":
        return "border-rarity-unique";
      default:
        return "border-neutral-300";
    }
  } else {
    return "";
  }
};

export const getItemSpecialColor = (
  imageId: string,
  type: string
): string | undefined => {
  if (type === "bg") {
    if (imageId.includes("emote")) {
      return "bg-primary-500";
    }
    switch (imageId) {
      case "shop_item_0071":
        return "bg-[#FF00E5]";
      case "shop_item_0058":
        return "bg-rarity-legendary";
      case "shop_item_0060":
        return "bg-success-300";
      case "MarketplaceBundle1":
      case "MarketplaceBundle2":
      case "MarketplaceBundle3":
        return "bg-[#FF00E5]";
      default:
        return "";
    }
  } else if (type === "border") {
    if (imageId.includes("emote")) {
      return "border-primary-500";
    }
    switch (imageId) {
      case "shop_item_0071":
        return "border-[#FF00E5]";
      case "shop_item_0058":
        return "border-rarity-legendary";
      case "shop_item_0060":
        return "border-success-300";
      default:
        return "border-primary-900";
    }
  }
};
